/* eslint-disable no-restricted-syntax */
import { apiService } from '../services';

const state = {
  // List of resources available from the db
  // items in this list will ne refreshed from data store automatically
  // Note endpoints are singular, but resource plural
  // art_forms: [],
  // art_media: [],
  // art_styles: [],
  // art_subjects: [],
  // shipping_methods: [],
};

const getters = {
  lookup: state => (resource, id) => {
    if (state[resource]) {
      const res = state[resource].find(element => element.id === id);
      return res === undefined ? 'unknown' : res.title;
    }
    return '';
  },
  resourceLookup: state => (resource, id) => state[resource].find(element => element.id === id),
  getArtMedia: state => artFormId =>
    state.art_media.filter(item => item.art_form_id === artFormId),
};

const actions = {
  async updateState({ commit, dispatch }) {
    // eslint-disable-next-line guard-for-in
    for (const resource in state) {
      // Loop through all resources and fetch from API
      try {
        // eslint-disable-next-line no-await-in-loop
        const data = await apiService.getResource(resource);
        commit('popResource', { resource, data });
      } catch (error) {
        dispatch('alert/error', error, { root: true });
      }
    }
  },
  // Generic resource functions
  async getResource({ commit, dispatch }, resource) {
    try {
      const data = await apiService.getResource(resource);
      commit('popResource', { resource, data });
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
};

const mutations = {
  popResource(state, { resource, data }) {
    state[resource] = data;
  },
};

export const resource = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/resource.module.js